import React, { useMemo } from 'react';
import styled from 'styled-components';

import { ApiFill } from '#/api/types';
import PaginationNoContentOverWarning from '#/components/basic/pagination/PaginationNoContentOverWarning';
import PaginationNumbers from '#/components/basic/pagination/PaginationNumbers';
import { PAGINATION_PAGES_LIMIT } from '#/config/constants';
import { redirectTo } from '#/lib/redirect';
import { useSelector } from '#/reduxState/store';

import MyTradesTable from './MyTradesTable';

const PaginationWrap = styled.div`
  text-align: center;
  padding: 20px 0;
`;

type Props = {
  page: number;
  pageLimit: number;
  fills: ApiFill[];
  isLoading: boolean;
  isPreviousData: boolean;
  totalCount?: number;
  onChangePage: (page: number) => void;
  vaultManagerWallet?: string;
};

export default function MyTradeHistoryMultiMarket({
  page,
  totalCount,
  pageLimit,
  isLoading,
  isPreviousData,
  fills,
  onChangePage,
  vaultManagerWallet,
}: Props) {
  const isMobile = useSelector(state => state.screen.isMobile);

  // TODO: TradeHistory Appear row animation is broken, disabled for now
  const appearAnimationEnabled = false;
  // const appearAnimationEnabledRef = useRef(false);
  // const [appearAnimationEnabled, setAppearAnimationEnabled] = useState(false);
  // useEffect(() => {
  //   // appearAnimationEnabledRef.current = false;
  //   const timeout = setTimeout(() => {
  //     // appearAnimationEnabledRef.current = true;
  //     setAppearAnimationEnabled(true);
  //   }, 1000);
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [page]);

  const tradesWithSymbols = useMemo(
    () =>
      (fills || []).map(fill => {
        const [baseAssetSymbol, quoteAssetSymbol] = fill.market.split('-');
        return {
          ...fill,
          baseAssetSymbol,
          quoteAssetSymbol,
        };
      }),
    [fills]
  );

  return (
    <>
      {page > PAGINATION_PAGES_LIMIT ? (
        <PaginationNoContentOverWarning />
      ) : (
        <MyTradesTable
          loading={isLoading || isPreviousData}
          trades={tradesWithSymbols}
          appearAnimationEnabled={appearAnimationEnabled}
          onSelectOrder={
            vaultManagerWallet
              ? undefined
              : isMobile
              ? (orderId, fillId) => {
                  redirectTo(`/wallet/history/trades/${orderId}/${fillId}`);
                }
              : undefined
          }
          vaultManagerWallet={vaultManagerWallet}
        />
      )}
      {!isLoading && (
        <PaginationWrap>
          <PaginationNumbers
            onSelect={onChangePage}
            selected={page}
            totalCount={totalCount}
            pageLimit={pageLimit}
          />
        </PaginationWrap>
      )}
    </>
  );
}
